(function () {
  angular.module('app.communications-analytics.subject-grade-comparisons', []);

})();